import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getCurrentUser } from "../../services/auth_service";
import { useAuth } from "../../services/authProvider";

const ProtectedRoute = ({ path, component: Component, render, ...rest }) => {
  const { accessToken } = useAuth();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!accessToken || !getCurrentUser())
          return (
            <Redirect
              to={{ pathname: "/user/login", state: { from: props.location } }}
            />
          );
        return Component ? <Component {...props} /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;
